let pendingHandoff = null

export function setCovaSyncHandoff(handoff) {
    pendingHandoff = handoff || null
}

export function consumeCovaSyncHandoff(type) {
    if (!pendingHandoff || pendingHandoff.type !== type) return null
    const handoff = pendingHandoff
    pendingHandoff = null
    return handoff
}
